
import { defineComponent } from 'vue';
import TheHeader from '@/shared/components/TheHeader.vue';
import TheFooter from '@/shared/components/TheFooter.vue';
import FeedbackModal from '@/feedback/FeedbackModal.vue';
import store from '@/store';
import { mapGetters } from 'vuex';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    FeedbackModal,
  },
  props: {
    router: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      domain: config.DOMAIN,
      windowWidth: 0,
      windowHeight: 0,
      feedbackSoundUrl: config.BASE_URL + '/sounds/feedback.mp3',
      showFeedbackModal: false,
      metaDescription: '',
    };
  },
  computed: {
    ...mapGetters(['isMobile', 'isMenuOpened', 'showFeedback', 'kabernetContext']),
    showLikeBarFix(): boolean {
      return this.$route && this.$route.name === 'AdDetail';
    },
    showHeader(): boolean {
      return this.$route && (!this.$route.meta || typeof this.$route.meta.showHeader === 'undefined' || this.$route.meta.showHeader === true);
    },
    showFooter(): boolean {
      return (
        !this.kabernetContext.isApp ||
        (this.$route && (!this.$route.meta || typeof this.$route.meta.showFooter === 'undefined' || this.$route.meta.showFooter === true))
      );
    },
    isSearchPage(): boolean {
      return this.$route && this.$route.name === 'AdSearch';
    },
    generateCanonicalUrl(): boolean {
      return !this.isSearchPage && window.location.search && window.location.search.length > 0;
    },
    canonicalUrl() {
      return window.location.href.split(/[?#]/)[0];
    },
  },
  watch: {
    isMobile: function (newVal) {
      if (!newVal) {
        document.body.classList.remove('noscroll');
      }
    },
    showFeedback: function (newVal) {
      if (newVal) {
        this.triggerFeedbackModal();
      } else {
        this.showFeedbackModal = false;
      }
    },
    isMenuOpened: function (newVal) {
      if (newVal) {
        if (this.isMobile) document.body.classList.add('noscroll');
      } else {
        document.body.classList.remove('noscroll');
      }
    },
  },
  async created() {
    this.metaDescription = this.$t('App.meta-description', { domain: this.domain });

    this.getWindowSize();

    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowSize);

      //Init
      this.getWindowSize();
    });

    if (this.showFeedback) {
      setTimeout(() => {
        this.triggerFeedbackModal();
      }, 3000);
    }
  },
  beforeCreate() {
    store.commit('initialiseStore');
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.getWindowSize);
  },
  methods: {
    getWindowSize() {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowHeight = document.documentElement.clientHeight; //important for map height
      store.dispatch('resize', { width: this.windowWidth, height: this.windowHeight });
    },
    triggerFeedbackModal() {
      this.showFeedbackModal = !this.showFeedbackModal;
      if (this.$refs.feedbackAudio) {
        (this.$refs.feedbackAudio as any).play();
      }
    },
    closeFeedback() {
      store.commit('showFeedback', false);
    },
  },
});
